import { InternalStandardProps } from "@mui/material";
import { Layout } from "../Layout";
import { styled } from "@mui/material/styles";
import { AppHeader } from "JS/React/Components/AppHeader";
import { useNavigate } from "react-router-dom";
import { useRouting } from "JS/React/Hooks/Routes";
import { DocumentsList } from "./DocumentList";
import { useGlobalNavStack } from "JS/React/Hooks/NavStack";

const StyledRoot = styled("div")({});

export interface DocumentsProps
    extends InternalStandardProps<
        React.DetailedHTMLProps<
            React.HTMLAttributes<HTMLDivElement>,
            HTMLDivElement
        >
    > {}

export const Documents = (props: DocumentsProps) => {
    const { className, ...rest } = props;
    const navigate = useNavigate();
    const { linkProvider } = useRouting();
    const { homeStack } = useGlobalNavStack();

    const onBackClick = () => {
        if (!homeStack?.isHomeTrack) {
            navigate(linkProvider.react.more().index());
        } else {
            navigate(linkProvider.react.home());
        }
    };

    return (
        <Layout>
            <StyledRoot {...rest} className={className}>
                <AppHeader
                    title={"Documents"}
                    canGoBack
                    searchable={false}
                    onBackClick={onBackClick}
                />
                <DocumentsList />
            </StyledRoot>
        </Layout>
    );
};
